import { schemaQuerySnapshotQueryOptions } from '@valian/react-kitchen-sink'

import { collections } from '../../schema'

export const nationalAndFallbackPromotionsQuery = (initiativeId: string) =>
  schemaQuerySnapshotQueryOptions({
    queryKey: ['promotions', 'national', 'fallback', initiativeId],
    factory: collections.promotions,
    query: {
      name: `national and fallback promotions for ${initiativeId}`,
      where: [
        ['initiativeId', '==', initiativeId],
        ['type', 'in', ['national', 'fallback']],
      ],
      orderBy: [['partnerName', 'asc']],
    },
  })

export const regionPromotionsQuery = ({ regionId, initiativeId }: { regionId: string; initiativeId: string }) =>
  schemaQuerySnapshotQueryOptions({
    queryKey: ['promotions', 'region', regionId, initiativeId],
    factory: collections.promotions,
    query: {
      name: `promotions for region ${regionId} and initiative ${initiativeId}`,
      where: [
        ['initiativeId', '==', initiativeId],
        ['regionId', '==', regionId],
      ],
      orderBy: [['partnerName', 'asc']],
    },
  })
